export const wooSettings = [
	{
		id: 'show_on_woocommerce',
		label: 'Load on all WooCommerce pages',
		help: 'The campaign will load on any page where WooCommerce templates are used.',
		show: '-never-',
	},
	{
		id: 'is_wc_shop',
		label: 'Product Archive Page (shop)',
		help: 'The campaign will load on the product archive page (shop).',
	},
	{
		id: 'is_wc_product',
		label: 'Single Product',
		help: 'The campaign will load on any single product.',
	},
	{
		id: 'is_wc_cart',
		label: 'Cart',
		help: 'The campaign will load on the cart page.',
	},
	{
		id: 'is_wc_checkout',
		label: 'Checkout Page',
		help: 'The campaign will load on the checkout page.',
	},
	{
		id: 'is_wc_account',
		label: 'Customer Account Page',
		help: 'The campaign will load on the customer account page.',
	},
	{
		id: 'is_wc_endpoint',
		label: 'Load on all WooCommerce Endpoints',
		help: 'The campaign will load on any WooCommerce endpoint.',
	},
	{
		id: 'is_wc_endpoint_order_pay',
		label: 'Order Pay Endpoint',
		help: 'The campaign will show when the endpoint page for order pay is displayed.',
	},
	{
		id: 'is_wc_endpoint_order_received',
		label: 'Order Received Endpoint',
		help: 'The campaign will show when the endpoint page for order received is displayed.',
	},
	{
		id: 'is_wc_endpoint_view_order',
		label: 'View Order Endpoint',
		help: 'The campaign will show when the endpoint page for order received is displayed.',
	},
	{
		id: 'is_wc_endpoint_edit_account',
		label: 'Edit Account Endpoint',
		help: 'The campaign will show when the endpoint page for edit account is displayed.',
	},
	{
		id: 'is_wc_endpoint_edit_address',
		label: 'Edit Address Endpoint',
		help: 'The campaign will show when the endpoint page for edit address is displayed.',
	},
	{
		id: 'is_wc_endpoint_lost_password',
		label: 'Lost Password Endpoint',
		help: 'The campaign will show when the endpoint page for lost password is displayed.',
	},
	{
		id: 'is_wc_endpoint_customer_logout',
		label: 'Logout Endpoint',
		help: 'The campaign will show when the endpoint page for logout is displayed.',
	},
	{
		id: 'is_wc_endpoint_add_payment_method',
		label: 'Add Payment Method Endpoint',
		help: 'The campaign will show when the endpoint page for add payment method is displayed.',
	},
];

export const eddSettings = [
	{
		id: 'show_on_edd',
		label: 'Load on all Easy Digital Downloads pages',
		help: 'The campaign will load on any Easy Digital Downloads page.',
		hide: true,
	},
	{
		id: 'is_edd_download',
		label: 'Single Download',
		help: 'The campaign will load on any single download.',
	},
	{
		id: 'is_edd_checkout',
		label: 'Primary Checkout Page',
		help: 'The campaign will load on the Primary Checkout Page.',
	},
	{
		id: 'is_edd_success_page',
		label: 'Success Page',
		help: 'The campaign will load on the Success Page (Purchase Confirmation).',
	},
	{
		id: 'is_edd_failed_transaction_page',
		label: 'Failed Transaction Page',
		help: 'The campaign will load on the Failed Transaction Page.',
	},
	{
		id: 'is_edd_purchase_history_page',
		label: 'Purchase History Page',
		help: 'The campaign will load on the Purchase History Page.',
	},
];

export const mpSettings = {
	memberships: [
		{
			id: 'show_to_mbp_membership_member',
			name: 'showMbpMembershipMember',
			label: 'Can show for active Members of the following Memberships:',
			tooltip: 'Determines if user/member should be able to view this campaign.',
			options: 'memberships',
			default: [],
		},
		{
			id: 'show_not_to_mbp_membership_member',
			name: 'showNotMbpMembershipMember',
			label: 'Can NOT show for active Members of the following Memberships:',
			tooltip: 'Determines if user/member should be able to view this campaign.',
			options: 'memberships',
			default: [],
		},
		{
			id: 'show_to_mbp_group_member',
			name: 'showMbpGroupMember',
			label: 'Can show for active Members of the following Groups:',
			tooltip: 'Determines if user/member should be able to view this campaign.',
			options: 'groups',
			default: [],
		},
		{
			id: 'show_not_to_mbp_group_member',
			name: 'showNotMbpGroupMember',
			label: 'Can NOT show for active Members of the following Groups:',
			tooltip: 'Determines if user/member should be able to view this campaign.',
			options: 'groups',
			default: [],
		},
	],
	pages: [
		{
			id: 'show_on_mbp_group_pages',
			name: 'showMbpGroupPages',
			label: 'Show on these Group pages:',
			tooltip: 'Show if the user is on the following Groups page.',
			options: 'groups',
			default: [],
		},
		{
			id: 'show_on_mbp_membership_pages',
			name: 'showMbpMemebershipPages',
			label: 'Show on these Membership pages:',
			tooltip: 'Show if the user is on the following Memberships page.',
			options: 'memberships',
			default: [],
		},
		{
			id: 'show_on_mbp_register_pages',
			name: 'showMbpRegisterPages',
			label: 'Show on the register/signup page for these Memberships:',
			tooltip: 'Show if the user is on the registration page of the following Memberships page.',
			options: 'memberships',
			default: [],
		},
		{
			id: 'show_on_mbp_checkout_pages',
			name: 'showMbpCheckoutPages',
			label: 'Show on the checkout page for these Memberships:',
			tooltip: 'Show if the user is on the checkout page for the following Memberships page.',
			options: 'memberships',
			default: [],
		},
	],
	globalPages: [
		{
			id: 'is_mbp_register',
			label: 'The campaign will load on the registration page.',
			optionLabel: 'Register',
		},
		{
			id: 'is_mbp_checkout',
			label: 'The campaign will load on the checkout page.',
			optionLabel: 'Checkout',
		},
		{
			id: 'is_mbp_thank_you',
			label: 'The campaign will load on the thank you page.',
			optionLabel: 'Thank You',
		},
	],
	addOns: [
		{
			id: 'show_on_mbp_course_pages',
			name: 'showMbpCoursePages',
			label: 'Show on Courses:',
			tooltip: 'Show if the user is on the following Course pages.',
			options: 'courses',
			default: [],
		},
		{
			id: 'show_on_mbp_lesson_pages',
			name: 'showMbpLessonPages',
			label: 'Show on Lessons:',
			tooltip: 'Show if the user is on the following Lesson pages.',
			options: 'lessons',
			default: [],
		},
		{
			id: 'show_on_mbp_quiz_pages',
			name: 'showMbpQuizPages',
			label: 'Show on Quizzes:',
			tooltip: 'Show if the user is on the following Quiz page.',
			options: 'quizzes',
			default: [],
		},
	],
};
